import React from "react";
import PropTypes from "prop-types";

import {ArticleLink} from "./ArticleLink";

const SKELETON_COUNT = 3;

ArticleList.propTypes = {
  articles: PropTypes.array,
  isLoading: PropTypes.bool
}

export function ArticleList(props) {
  if (props.isLoading) {
    return (
      <div className="support-form-article-list">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <ArticleLink key={index} isLoading/>
        ))}
      </div>
    )
  }

  return (
    <div className="support-form-article-list">
      {props.articles.map((article, index) => (
        <ArticleLink key={index} url={article.html_url} name={article.name}/>
      ))}
    </div>
  );
}
